import { render, staticRenderFns } from "./userSideBar.vue?vue&type=template&id=70f63d48"
import script from "./userSideBar.vue?vue&type=script&lang=js"
export * from "./userSideBar.vue?vue&type=script&lang=js"
import style0 from "./userSideBar.vue?vue&type=style&index=0&id=70f63d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports